import { useRef } from "react";

export const useVerificationCode = () => {
  const firstInput = useRef<HTMLInputElement>(null);
  const secondInput = useRef<HTMLInputElement>(null);
  const thirdInput = useRef<HTMLInputElement>(null);
  const fourthInput = useRef<HTMLInputElement>(null);

  const handleSelectInputElement = () => {
    if (firstInput.current?.value === "") {
      firstInput.current.focus();
    } else if (secondInput.current?.value === "") {
      secondInput.current.focus();
    } else if (thirdInput.current?.value === "") {
      thirdInput.current.focus();
    } else if (fourthInput.current) {
      fourthInput.current.focus();
    }
  };

  return {
    refArray: [firstInput, secondInput, thirdInput, fourthInput],
    handleSelectInputElement,
  };
};
